import React, { useEffect, useRef, useState } from 'react';
import ReactApexChart from "react-apexcharts";
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CLabel from '../../../../../Common/CLabel';
import PropTypes from 'prop-types';
import './radial.css'
import i18next from 'i18next';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import { TooltipHost } from '@fluentui/react';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import { useSelector } from 'react-redux';

function SG3KPI_RADIAL_DUMMY(props) {
  	const { t } = useTranslation();

	const colorGet = (color) => {
		switch (color) {
			case 'v':
				return '#1f7be8d9'
				break;
			case 'a':
				return '#1f7be8d9'
				break;
			case 'r':
				return '#1f7be8d9'
				break;
			default:
				return '#1f7be8d9'
				break;
		}
	}

	const xValueMin = 200000;
	const xValueMax = 300000;

	const [options, setOptions] = useState({
		plotOptions: {
			bar: {
				barHeight: '100%',
				distributed: true,
				horizontal: true,
				dataLabels: {
					position: 'bottom'
				},
			}
		},
		legend: {
			show: false,
		},
		colors: ['v', 'r', 'a', 'v'].map(x => colorGet(x)),
		dataLabels: {
			enabled: true,
			textAnchor: 'start',
			style: {
				colors: ['#fff']
			},
			formatter: function (val, opt) {
				return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val + "%"
			},
			offsetX: 0,
			dropShadow: {
				enabled: true
			},
		},
		stroke: {
			width: 1,
			colors: ['#fff']
		},
		xaxis: {
			categories: ['KPI 1', 'KPI 2', 'KPI 3', 'KPI 4'],
		},
		yaxis: {
			labels: {
				show: false
			}
		},
		annotations: {
			xaxis: [
				{
					x: xValueMin,
					borderColor: "#d93b3b",
					borderWidth: 2,
					strokeDashArray: 0,
					opacity: 1,
					label: {
						borderColor: "#d93b3b",
						style: {
							color: "#fff",
							background: "#d93b3b",
						},
					},
				},{
					x: xValueMax,
					borderColor: "#25aa34",
					borderWidth: 2,
					strokeDashArray: 0,
					opacity: 1,
					label: {
						borderColor: "#25aa34",
						style: {
							color: "#fff",
							background: "#25aa34",
						},
					},
				},
			],
		},
		tooltip: {
			theme: 'dark',
			x: {
				show: false
			},
			y: {
				title: {
					formatter: function (value) {
						return value + "%";
					}
				}
			}
		}
	});
  
	const [series, setSeries] = useState([{data: [454345, 728537, 231653, 537098]}]);
  
	const title = 'Nombre del KPI';
	const subtitle = t('data-lang-lbl-um');

	return  <div className='px-3 h-100 d-flex'>
				<Col>
					<ReactApexChart
						options={options}
						series={series}
						type="bar"
						height={300}
					/>
				</Col>
			</div>
}

export default SG3KPI_RADIAL_DUMMY;